import "./App.css";
import "../src/styles/main.scss";
import MainRoutes from "./routes/routes";
import { useEffect, useRef } from "react";
import Cookies from "js-cookie";
import { useDispatch, useSelector } from "react-redux";
import { LOGOUT } from "./redux/auth/authType";
import { logout } from "./utils/auth";
import decode from "jwt-decode";
import React from "react";

function App() {
  const { token } = useSelector((state) => (state as any)?.authReducer);

  const dispatch = useDispatch();
  const idleTimer = useRef<any>(null);
  const intervalTimer = useRef<any>(null);

  // 🔥 1) Safe Logout Function
  const doLogout = () => {
    Cookies.remove("token"); // correct token cookie
    Cookies.remove("services");

    dispatch({ type: LOGOUT });

    // React style navigation
    window.location.replace("/");
  };

  // 🔥 2) Inactivity Logout (1 Hour Idle)
  const handleIdleness = () => {
    const resetTimer = () => {
      if (idleTimer.current) clearTimeout(idleTimer.current);

      idleTimer.current = setTimeout(doLogout, 60 * 60 * 1000); // 1 hour
    };

    // register all user activity events
    ["click", "mousemove", "keydown", "scroll", "touchstart"].forEach((evt) => {
      window.addEventListener(evt, resetTimer);
    });

    resetTimer(); // initial call
  };

  // 🔥 3) Token Expiry Check
  const checkTokenExpiry = () => {
    if (!token) return;

    try {
      const decoded: any = decode(token);
      const exp = decoded.exp * 1000;
      const now = Date.now();

      if (now >= exp) {
        doLogout();
      }
    } catch (err) {
      doLogout();
    }
  };

  useEffect(() => {
    if (token) {
      handleIdleness();

      // check token every 10 seconds (optimized)
      intervalTimer.current = setInterval(checkTokenExpiry, 10000);
    }

    return () => {
      if (intervalTimer.current) clearInterval(intervalTimer.current);
      if (idleTimer.current) clearTimeout(idleTimer.current);
    };
  }, [token]);

  return <MainRoutes />;
}

export default App;
